import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  Divider,
  SelectChangeEvent,
} from "@mui/material";
import {
  Add,
  Delete,
  Download,
  FilterList,
  MoreVert,
  Search,
  FirstPage,
  LastPage,
  Remove,
  CloudUpload,
  Close,
  PhotoCamera,
} from "@mui/icons-material";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import { styled } from "@mui/system";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  getVendors,
  vendorSearchParams,
  createVendor,
  uploadItemPhoto,
  deleteVendor,
  updateVendor,
  fetchVendors,
  getVendorById,
  fetchVendorPhotoBlob,
  createVendorLocation,
} from "../services/vendorService.tsx";
import {
  LocationSearchParams,
  getLocations,
  createLocation,
  editLocation,
  deleteLocation,
} from "../services/locationService.tsx";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

interface Vendor {
  vendorId: string;
  vendorName: string; // Perbaiki typo dari vendorNameame
  vendorAddress: string;
  vendorContactNumber: string;
  vendorEmail: string;
  vendorType: string;
  vendorTaxId: string;
  vendorBankName: string;
  vendorBankAccountNo: string;
  vendorBankAccountName: string;
  vendorStatus: string;
  photoVendor?: string; // Tambahkan field untuk foto
}

interface AdvancedSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearchResults: (results: Vendor[]) => void;
}

const bankData = [
  "-",
  "Bank Rakyat Indonesia (BRI) - 002",
  "Bank Mandiri - 008",
  "Bank Negara Indonesia (BNI) - 009",
  "Bank Tabungan Negara (BTN) - 200",
  "Bank Syariah Indonesia (BSI) - 451",
  "Bank Central Asia (BCA) - 014",
  "Bank CIMB Niaga - 022",
  "Bank Danamon - 011",
  "Bank Permata - 013",
  "Bank Maybank Indonesia - 016",
  "Bank Panin - 019",
  "Bank OCBC NISP - 028",
  "Bank Sinarmas - 153",
  "Bank Mega - 426",
  "Bank KB Bukopin - 441",
  "Bank BTPN - 213",
  "Bank UOB Indonesia - 023",
  "Bank BCA Syariah - 536",
  "Bank Muamalat - 147",
  "Bank BTPN Syariah - 547",
  "Bank Victoria International - 566",
  "Bank Woori Saudara - 212",
  "Bank Jago - 542",
  "Bank Neo Commerce - 490",
  "Allo Bank - 567",
  "SeaBank - 535",
  "Bank Amar Indonesia - 531",
  "Bank Aladin Syariah - 947",
  "Bank Jenius (BTPN) - 213",
  "Bank Raya (BRI Agro) - 494",
  "Bank MNC Internasional - 485",
  "Bank Hana - 484",
  "Bank QNB Indonesia - 167",
  "Bank Mayora - 553",
  "Bank Index Selindo - 555",
  "Bank Sahabat Sampoerna - 523",
  "Bank Oke Indonesia - 526",
  "Bank Ina Perdana - 513",
  "Bank Ganesha - 161",
  "Bank Maspion - 157",
  "Bank Capital Indonesia - 054",
  "Bank Resona Perdania - 047",
  "Bank ICBC Indonesia - 164",
  "Bank JTrust Indonesia - 095",
  "Bank Artha Graha Internasional - 037",
  "Bank Commonwealth - 950",
  "Bank CTBC Indonesia - 949",
  "Bank of China - 069",
  "Standard Chartered Bank - 050",
  "Citibank - 031",
  "JP. Morgan Chase Bank, N.A. - 032",
  "Bank of America, N.A - 033",
  "Bank Mizuho Indonesia - 048",
  "Bank Sumitomo Mitsui Indonesia - 045",
  "The Bank of Tokyo Mitsubishi UFJ LTD - 042",
  "American Express Bank LTD - 030",
  "Bank DKI Jakarta - 111",
  "Bank Jabar Banten (BJB) - 110",
  "Bank BPD DIY - 112",
  "Bank Jateng - 113",
  "Bank Jatim - 114",
  "Bank Jambi - 115",
  "Bank Aceh - 116",
  "Bank Sumut - 117",
  "Bank Nagari (Sumbar) - 118",
  "Bank Riau Kepri - 119",
  "Bank Sumsel Babel - 120",
  "Bank Lampung - 121",
  "Bank Kalsel - 122",
  "Bank Kalbar - 123",
  "Bank Kaltimtara - 124",
  "Bank Kalteng - 125",
  "Bank Sulselbar - 126",
  "Bank SulutGo - 127",
  "Bank NTB - 128",
  "Bank BPD Bali - 129",
  "Bank NTT - 130",
  "Bank Maluku Malut - 131",
  "Bank Papua - 132",
  "Bank Bengkulu - 133",
  "Bank Sulteng - 134",
  "Bank Sultra - 135",
  "Bank Banten - 137",
];

const VendorListPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddVendorDialog, setOpenAddVendorDialog] = useState(false);
  const [openEditVendorDialog, setOpenEditVendorDialog] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingBank, setLoadingloadingBank] = useState(false);
  const [error, setError] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10); // Jumlah item per halaman
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [currentPage, setCurrentPage] = useState(1); // Halaman aktif
  const [totalPages, setTotalPages] = useState(1); // Total halaman

  const displayedRows = rows.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  // Fungsi untuk mengambil data vendor

  // Vendor Data Table ========================================================================
  // Fungsi untuk mengambil data vendor
  const reloadVendor = async () => {
    setIsLoading(true);
    setError(""); // Reset error sebelum memuat ulang data
    try {
      const result = await getVendors({
        ...filterParams, // ← nanti kamu tinggal simpan filter dari search input di state ini
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });
      setRows(result.data);
      setTotalItems(result.total);
      setTotalPages(result.pagination.totalPages);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const offset = (currentPage - 1) * rowsPerPage;

  const [filterParams, setFilterParams] = useState<{
    vendorId?: string;
    vendorName?: string;
    vendorAddress?: string;
    vendorContactNumber?: string;
    vendorEmail?: string;
    vendorType?: string;
    vendorTaxId?: string;
    vendorBankName?: string;
    vendorStatus?: string;
    keyword?: string;
  }>({});

  // Sort
  const [sortConfig, setSortConfig] = useState<{
    orderBy: string;
    order: "asc" | "desc";
  }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };

  // Memanggil data saat komponen pertama kali dimuat
  useEffect(() => {
    reloadVendor();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  // Fungsi untuk menangani pemilihan checkbox baris
  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const CustomTextField = styled(TextField)({
    "& .MuiInputBase-input": {
      backgroundColor: "#f5f5f5",
      borderRadius: 4,
      padding: "8px 12px",
    },
  });

  const handleDeleteVendor = async (confirm: boolean = true) => {
    const confirmDelete = await Swal.fire({
      title: "Apakah Anda yakin?",
      text: "Anda tidak dapat mengembalikan data yang dihapus!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Batal",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      const rowsToDelete = [...selectedRows];

      for (const nik of rowsToDelete) {
        await deleteVendor(String(nik)); // 🔄 Gunakan fungsi API dari vendorServices
      }

      Swal.fire({
        icon: "success",
        title: "Vendor berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]); // Kosongkan pilihan
      setRows((prevRows) =>
        prevRows.filter((row) => !rowsToDelete.includes(row.vendorId))
      ); // Update daftar vendor
      setOpenDeleteDialog(false); // Tutup dialog
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus vendor",
        text:
          error.response?.data?.message || error.message || "Terjadi kesalahan",
      });
    }
  };

  // 🔄 Pastikan selectedRows update setelah rows berubah
  useEffect(() => {
    setSelectedRows([]);
  }, [rows]);

  const [filters, setFilters] = useState([{ field: "vendorName", value: "" }]);
  const [vendors, setVendors] = useState<Vendor[]>([]);

  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "vendorName", label: "Vendor Name" },
    { value: "vendorAddress", label: "Vendor Address" },
    { value: "vendorType", label: "Vendor Type" },
    { value: "vendorContactNumber", label: "Vendor Contact Number" },
    { value: "vendorEmail", label: "Vendor Email" },
    { value: "vendorStatus", label: "Vendor Status" },
  ];

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `ItemSearchParams`
      const searchParams: vendorSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getItems(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "vendorName", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getVendors({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams({
        keyword: searchQuery,
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: "Preparing Export...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatVendorForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one vendor to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.vendorId))
      //   .map(formatVendorForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Vendors");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Vendors_${date}.xlsx`);

      // Tutup loading
      Swal.close();
    } catch (error) {
      console.error("Export failed:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: error.message || "Failed to export vendor data",
      });
    }
  };

  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    const allVendors = await getVendors({
      ...filterParams,
      limit: 10000, // Ambil semua data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    // Helper function to format empty values
    const formatEmpty = (value: any) => value || "-";

    // Helper function to format location data safely
    const formatLocation = (vendor: any, field: string) => {
      return vendor.Locations?.[0]?.[field] || "-";
    };

    const formatTimestampz = (
      timestamp: string | Date | null,
      withTime: boolean = true
    ): string => {
      if (!timestamp) return "-";

      const date = new Date(timestamp);

      if (isNaN(date.getTime())) return "Invalid Date";

      // Format tanggal: DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const datePart = `${day}/${month}/${year}`;

      if (!withTime) return datePart;

      // Format waktu: HH:MM:SS
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const timePart = `${hours}:${minutes}:${seconds}`;

      return `${datePart} ${timePart}`;
    };

    // Transform data for export
    return allVendors.data.map((vendor) => ({
      // Vendor Information
      "Nama Vendor": formatEmpty(vendor.vendorName),
      "Alamat Vendor": formatEmpty(vendor.vendorAddress),
      "Nomor Kontak": formatEmpty(vendor.vendorContactNumber),
      "Email Vendor": formatEmpty(vendor.vendorEmail),
      "Tipe Vendor": formatEmpty(vendor.vendorType),
      "Status Vendor": formatEmpty(vendor.vendorStatus),

      // Tax and Banking Information
      NPWP: formatEmpty(vendor.vendorTaxId),
      "Nama Bank": formatEmpty(vendor.vendorBankName),
      "Nomor Rekening": formatEmpty(vendor.vendorBankAccountNo),
      "Nama Pemilik Rekening": formatEmpty(vendor.vendorBankAccountName),

      // Location Information (safely handle nested data)
      Kota: formatLocation(vendor, "city"),
      Provinsi: formatLocation(vendor, "province"),
      Kecamatan: formatLocation(vendor, "district"),
      Negara: formatLocation(vendor, "country"),
      Longitude: formatLocation(vendor, "longitude"),
      Latitude: formatLocation(vendor, "latitude"),
      "Tanggal Dibuat": formatTimestampz(vendor.createdAt) || "-",
      "Tanggal Diupdate": formatTimestampz(vendor.updateAt) || "-",

      // Additional fields if needed
      // "Catatan": formatEmpty(vendor.notes),
    }));
  };

  // Fungsi untuk memformat data vendor untuk export
  const formatVendorForExport = (vendor) => ({
    vendorId: vendor.vendorId,
    vendorNameame: vendor.vendorNameame,
    vendorAddress: vendor.vendorAddress,
    vendorType: vendor.vendorType,
    vendorContactNumber: vendor.vendorContactNumber,
    vendorEmail: vendor.vendorEmail,
    vendorStatus: vendor.vendorStatus,
    // ... tambahkan field lainnya sesuai kebutuhan
  });

  // add vendor data ========================================================================
  const [vendorDataAdd, setVendorDataAdd] = useState<{
    vendorName: string;
    vendorAddress: string;
    vendorCountry: string;
    vendorProvince: string;
    vendorCity: string;
    vendorDistrict: string;
    vendorContactNumber: string;
    vendorEmail: string;
    vendorType: string;
    vendorTaxId: string;
    vendorBankName: string;
    vendorBankAccountNo: string;
    vendorBankAccountName: string;
    vendorStatus: string;
    latitude: string;
    longitude: string;
    file: File | null;
  }>({
    vendorName: "",
    vendorAddress: "",
    vendorCountry: "",
    vendorProvince: "",
    vendorCity: "",
    vendorDistrict: "",
    vendorContactNumber: "",
    vendorEmail: "",
    vendorType: "",
    vendorTaxId: "",
    vendorBankName: "",
    vendorBankAccountNo: "",
    vendorBankAccountName: "",
    vendorStatus: "",
    latitude: "",
    longitude: "",
    file: null,
  });

  const resetAddForm = () => {
    setVendorDataAdd({
      vendorName: "",
      vendorAddress: "",
      vendorCountry: "",
      vendorProvince: "",
      vendorCity: "",
      vendorDistrict: "",
      vendorContactNumber: "",
      vendorEmail: "",
      vendorType: "",
      vendorTaxId: "",
      vendorBankName: "",
      vendorBankAccountNo: "",
      vendorBankAccountName: "",
      vendorStatus: "",
      latitude: "",
      longitude: "",
      file: null,
    });
    setPreviewUrl("");
  };

  const handleOpenAddDialog = () => {
    resetAddForm();
    setOpenAddVendorDialog(true);
  };

  const handleInputChangeAdd = (e) => {
    const { name, value } = e.target;
    setVendorDataAdd({ ...vendorDataAdd, [name]: value });
  };

  const [errorsAdd, setErrorsAdd] = useState({
    vendorName: false,
    vendorAddress: false,
    vendorCountry: false,
    vendorProvince: false,
    vendorCity: false,
    vendorDistrict: false,
    vendorContactNumber: false,
    vendorEmail: false,
    vendorType: false,
    vendorTaxId: false,
    vendorBankName: false,
    vendorBankAccountNo: false,
    vendorBankAccountName: false,
    vendorStatus: false,
    latitude: false,
    longitude: false,
  });

  const validateFormAdd = () => {
    let newErrors = {
      vendorName: !vendorDataAdd.vendorName,
      vendorAddress: !vendorDataAdd.vendorAddress,
      vendorCountry: !vendorDataAdd.vendorCountry,
      vendorProvince: !vendorDataAdd.vendorProvince,
      vendorCity: !vendorDataAdd.vendorCity,
      vendorDistrict: !vendorDataAdd.vendorDistrict,
      vendorContactNumber: !vendorDataAdd.vendorContactNumber,
      vendorEmail: !vendorDataAdd.vendorEmail,
      vendorType: !vendorDataAdd.vendorType,
      vendorTaxId: !vendorDataAdd.vendorTaxId,
      vendorBankName: !vendorDataAdd.vendorBankName,
      vendorBankAccountNo: !vendorDataAdd.vendorBankAccountNo,
      vendorBankAccountName: !vendorDataAdd.vendorBankAccountName,
      vendorStatus: !vendorDataAdd.vendorStatus,
      latitude: !vendorDataAdd.latitude,
      longitude: !vendorDataAdd.longitude,
    };
    setErrorsAdd(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const handleSaveAdd = async () => {
    try {
      if (!validateFormAdd()) {
        showPopupMandatoryError();
        return;
      }
      // Step 1: Create item category
      const response = await createVendor(vendorDataAdd); // get response with `id` or `code`
      const locData = {
        locationName: vendorDataAdd.vendorAddress,
        city: vendorDataAdd.vendorCity,
        province: vendorDataAdd.vendorProvince,
        district: vendorDataAdd.vendorDistrict,
        country: vendorDataAdd.vendorCountry,
        mapsLocation: vendorDataAdd.longitude + "," + vendorDataAdd.latitude,
        longitude: vendorDataAdd.longitude,
        latitude: vendorDataAdd.latitude,
      };

      let newLocation;

      if (response.vendorId) {
        newLocation = await createLocation(locData);
      }
      let newVendorLocation;
      if (response.vendorId && newLocation.locationId) {
        newVendorLocation = await createVendorLocation({
          vendorId: response.vendorId,
          locationId: newLocation.locationId,
        });
      }

      // Step 2: Upload photo if available
      if (vendorDataAdd.file) {
        await uploadItemPhoto(response.vendorId, vendorDataAdd.file);
      }

      Swal.fire({
        icon: "success",
        title: "Vendor berhasil ditambahkan",
        confirmButtonColor: "#0F62FE",
      });
      setOpenAddVendorDialog(false);
      reloadVendor();
      // TODO: refresh item list
    } catch (error: any) {
      let errorTitle = "Gagal membuat vendor";
      let errorDetails = "";

      // Handle backend error response
      if (error.response?.data) {
        const backendError = error.response.data;

        // Debug log untuk melihat struktur error
        console.log(
          "Backend Error Structure:",
          JSON.stringify(backendError, null, 2)
        );

        // Main error message
        errorTitle = backendError.error || errorTitle;

        // Handle all possible email validation error formats - PERBAIKAN UTAMA
        const isEmailValidationError =
          // Case 1: Error in details (Sequelize style)
          (backendError.details &&
            /validation isEmail on (email|vendorEmail)/i.test(
              backendError.details
            )) ||
          // Case 2: Error in errors array (Sequelize validation errors)
          (backendError.errors &&
            backendError.errors.some(
              (err: any) =>
                (err.path === "email" || err.path === "vendorEmail") &&
                err.validatorKey === "isEmail"
            )) ||
          // Case 3: Error in message (generic API responses)
          (backendError.message &&
            /email.*invalid/i.test(backendError.message));

        if (isEmailValidationError) {
          errorTitle = "Format Email Tidak Valid";
          errorDetails =
            "• Format email tidak valid (contoh: nama@perusahaan.com)";
        }
        // Only use details if not an email error
        else if (backendError.details) {
          errorDetails = backendError.details;
        }

        // Handle validation errors (improved processing)
        if (backendError.errors) {
          const validationMessages = backendError.errors
            .map((err: any) => {
              // Handle both array and object error formats
              const errorObj = Array.isArray(err) ? err[0] : err;

              // Skip email errors since we already handled them
              if (
                (errorObj.path === "email" ||
                  errorObj.path === "vendorEmail") &&
                errorObj.validatorKey === "isEmail"
              ) {
                return null;
              }
              return `• ${errorObj.message || "Terjadi kesalahan validasi"}`;
            })
            .filter(Boolean) // Remove null entries
            .join("\n");

          if (validationMessages) {
            errorDetails = errorDetails
              ? `${errorDetails}\n${validationMessages}`
              : validationMessages;
          }
        }

        // Handle duplicate fields (improved formatting)
        if (backendError.duplicates) {
          const duplicateMessages = backendError.duplicates
            .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
            .join("\n");

          if (duplicateMessages) {
            errorDetails = errorDetails
              ? `${errorDetails}\n${duplicateMessages}`
              : duplicateMessages;
          }
        }
      }
      // Handle network or other errors
      else {
        errorDetails =
          error.message || "Terjadi kesalahan jaringan atau server";
      }

      // Show error in Swal (improved formatting)
      Swal.fire({
        icon: "error",
        title: errorTitle,
        html: `
          <div style="text-align: left;">
            <p style="font-weight: bold; margin-bottom: 10px; color: #d32f2f;">
              ${errorTitle}
            </p>
            ${
              errorDetails
                ? `<div style="
                    color: #5f2120;
                    background: #fdecea;
                    padding: 12px;
                    border-radius: 4px;
                    font-size: 0.9em;
                    border-left: 4px solid #d32f2f;
                    line-height: 1.5;
                  ">
                    ${errorDetails.replace(/\n/g, "<br>")}
                  </div>`
                : ""
            }
          </div>
        `,
        confirmButtonColor: "#0F62FE",
        width: "600px",
      });
    }
  };

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string>("");

  const handleFileUpload = (file: File) => {
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // Validasi format file
    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Format file tidak valid",
        text: "Hanya diperbolehkan file PNG, JPG, dan JPEG!",
        confirmButtonColor: "#0F62FE",
        allowOutsideClick: false,
        customClass: {
          popup: "swal-front",
        },
      });
      return;
    }

    // Validasi ukuran file
    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
        confirmButtonColor: "#0F62FE",
        allowOutsideClick: false,
        customClass: {
          popup: "swal-front",
        },
      });
      return;
    }

    // Jika ada preview sebelumnya, hapus untuk mencegah memory leak
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    // Simpan file ke state utama `vendorDataAdd`
    setVendorDataAdd((prev) => ({ ...prev, file }));

    // Simpan file ke state dan buat URL preview
    const newPreviewUrl = URL.createObjectURL(file);

    setSelectedFile(file);
    setPreviewUrl(newPreviewUrl);

    console.log("Preview URL:", newPreviewUrl);
    console.log("File disimpan dalam vendorDataAdd:", file);
  };

  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleCloseAdd = () => {
    setOpenAddVendorDialog(false);
    resetAddForm(); // Reset form saat ditutup
  };

  //edit vendor data ========================================================================
  const [isEditing, setIsEditing] = useState(false);

  const [selectedVendorId, setSelectedVendorId] = useState<number | null>(null);

  const [vendorDataEdit, setVendorDataEdit] = useState<{
    vendorId: string;
    locationId: string;
    vendorName: string;
    vendorAddress: string;
    vendorCountry: string;
    vendorProvince: string;
    vendorCity: string;
    vendorDistrict: string;
    vendorContactNumber: string;
    vendorEmail: string;
    vendorType: string;
    vendorTaxId: string;
    vendorBankName: string;
    vendorBankAccountNo: string;
    vendorBankAccountName: string;
    vendorStatus: string;
    latitude: string;
    longitude: string;
    file: File | null;
    photoVendor: string;
    previewUrl: string;
  }>({
    vendorId: "",
    locationId: "",
    vendorName: "",
    vendorAddress: "",
    vendorCountry: "",
    vendorProvince: "",
    vendorCity: "",
    vendorDistrict: "",
    vendorContactNumber: "",
    vendorEmail: "",
    vendorType: "",
    vendorTaxId: "",
    vendorBankName: "",
    vendorBankAccountNo: "",
    vendorBankAccountName: "",
    vendorStatus: "",
    latitude: "",
    longitude: "",
    file: null,
    photoVendor: "",
    previewUrl: "",
  });

  const handleOpenEditDialog = async (vendor) => {
    try {
      const photoVendor = vendor.photoVendor;

      let previewUrl;
      if (photoVendor && typeof photoVendor === "string") {
        previewUrl = await fetchVendorPhotoBlob(photoVendor);
      }

      await setVendorDataEdit({
        ...vendor,
        locationId: vendor.Locations[0].locationId,
        vendorCity: vendor.Locations[0].city,
        vendorProvince: vendor.Locations[0].province,
        vendorDistrict: vendor.Locations[0].district,
        vendorCountry: vendor.Locations[0].country,
        longitude: vendor.Locations[0].longitude,
        latitude: vendor.Locations[0].latitude,
        file: null,
        photoVendor: vendor.photoVendor,
        previewUrl,
      });

      // setIsLoading(true);
      // try {
      //   // 1. Gunakan parameter id yang diterima, bukan selectedVendorId
      //   const data = await getVendorById(id);

      //   // 2. Periksa jika data tidak ditemukan
      //   if (!data || !data.vendorId) {
      //     throw new Error("Vendor data not found");
      //   }

      //   // 3. Handle photo preview
      //   let previewUrl;
      //   if (data.photoVendor) {
      //     // Pastikan nama field sesuai dengan response API
      //     try {
      //       previewUrl = await fetchVendorPhotoBlob(data.photoVendor);
      //     } catch (photoError) {
      //       console.warn("Failed to load vendor photo:", photoError);
      //       // Tetap lanjut tanpa preview jika gagal load foto
      //     }
      //   }

      //   // 4. Set data ke form edit
      //   setVendorDataEdit({
      //     vendorId: data.vendorId,
      //     locationId: data.locationId,
      //     vendorName: data.vendorName || "",
      //     vendorAddress: data.vendorAddress || "",
      //     vendorCountry: data.vendorCountry || "",
      //     vendorProvince: data.vendorProvince || "",
      //     vendorCity: data.vendorCity || "",
      //     vendorDistrict: data.vendorDistrict || "",
      //     vendorContactNumber: data.vendorContactNumber || "",
      //     vendorEmail: data.vendorEmail || "",
      //     vendorType: data.vendorType || "",
      //     vendorTaxId: data.vendorTaxId || "",
      //     vendorBankName: data.vendorBankName || "",
      //     vendorBankAccountNo: data.vendorBankAccountNo || "",
      //     vendorBankAccountName: data.vendorBankAccountName || "",
      //     vendorStatus: data.vendorStatus || "active", // Default value jika kosong
      //     latitude: data.latitude || "",
      //     longitude: data.longitude || "",
      //     file: null,
      //     photoVendor: data.photoVendor || "",
      //     previewUrl: previewUrl,
      //   });

      //   // 5. Update state
      //   setSelectedVendorId(id);
      setOpenEditVendorDialog(true);
      setIsEditing(false);
    } catch (error) {
      console.error("Failed to fetch vendor data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal Memuat Vendor",
        text: error.message || "Data vendor tidak ditemukan",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusClass = (status: string) => {
    switch (status) {
      case "Suspended":
        return "statusRed";
      case "Inactive":
        return "statusGray";
      case "Active":
        return "statusGreen";
      default:
        return "";
    }
  };

  const handleInputChangeEdit = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | { target: { name: string; value: any } }
  ) => {
    const { name, value } = event.target;

    setVendorDataEdit((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    console.log("Updated Vendor Data:", name, value); // Debugging
  };

  const handleEditFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setVendorDataEdit({ ...vendorDataEdit, file });
  };

  const handleCloseEdit = () => {
    setOpenEditVendorDialog(false);
    setIsEditing(false); // Reset mode edit saat ditutup
    setSelectedVendorId(null);
  };

  const [errorsEdit, setErrorsEdit] = useState({
    vendorId: false,
    locationId: false,
    vendorName: false,
    vendorAddress: false,
    vendorCountry: false,
    vendorProvince: false,
    vendorCity: false,
    vendorDistrict: false,
    vendorContactNumber: false,
    vendorEmail: false,
    vendorType: false,
    vendorTaxId: false,
    vendorBankName: false,
    vendorBankAccountNo: false,
    vendorBankAccountName: false,
    vendorStatus: false,
    latitude: false,
    longitude: false,
  });

  const validateFormEdit = () => {
    const newErrors: any = {};

    const mandatoryFields = [
      "vendorName",
      "vendorAddress",
      "vendorCountry",
      "vendorProvince",
      "vendorCity",
      "vendorDistrict",
      "vendorContactNumber",
      "vendorEmail",
      "vendorType",
      "vendorTaxId",
      "vendorBankName",
      "vendorBankAccountNo",
      "vendorBankAccountName",
      "vendorStatus",
      "latitude",
      "longitude",
    ];

    // Jika tipe inorganic → wajib isi vendor company
    // if (vendorDataEdit.vendorType === "inorganic") {
    //   mandatoryFields.push("company");
    // }

    // Validasi setiap field
    mandatoryFields.forEach((field) => {
      if (
        !vendorDataEdit[field] ||
        vendorDataEdit[field].toString().trim() === ""
      ) {
        newErrors[field] = true;
      }
    });

    setErrorsEdit(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveEdit = async () => {
    if (validateFormEdit()) {
      try {
        const updatedVendor = await updateVendor(vendorDataEdit);

        const locData = {
          locationId: vendorDataEdit.locationId,
          locationName: vendorDataEdit.vendorAddress,
          city: vendorDataEdit.vendorCity,
          province: vendorDataEdit.vendorProvince,
          district: vendorDataEdit.vendorDistrict,
          country: vendorDataEdit.vendorCountry,
          mapsLocation:
            vendorDataEdit.longitude + "," + vendorDataEdit.latitude,
          longitude: vendorDataEdit.longitude,
          latitude: vendorDataEdit.latitude,
        };
        let updatedLocation;
        if (updatedVendor.vendorId) {
          updatedLocation = await editLocation(locData);
        }

        if (
          vendorDataEdit.file &&
          vendorDataEdit.file.name !== vendorDataEdit.photoVendor
        ) {
          await uploadItemPhoto(vendorDataEdit.file, vendorDataEdit.file);
        }

        Swal.fire({
          icon: "success",
          title: "Vendor berhasil diubah",
          confirmButtonColor: "#0F62FE",
        });

        setOpenEditVendorDialog(false);

        // 🔥 Update state `rows` agar tabel ikut berubah
        reloadVendor();
      } catch (error: any) {
        console.error("Error saat menyimpan data:", error);

        let errorTitle = "Gagal memperbarui data vendor";
        let errorDetails = "";

        // Penanganan error dari backend
        if (error.response?.data) {
          const backendError = error.response.data;
          errorTitle = backendError.error || errorTitle;

          // Handle khusus untuk error validasi email (updated regex pattern)
          if (
            backendError.details &&
            /validation isEmail on (vendorEmail|email)/i.test(
              backendError.details
            )
          ) {
            errorTitle = "Format Email Tidak Valid";
            errorDetails =
              "Harap masukkan alamat email yang benar (contoh: nama@perusahaan.com)";
          }
          // Handle error validasi lainnya
          else if (backendError.errors) {
            errorDetails = Object.values(backendError.errors)
              .flatMap((err: any) => {
                // Handle array of errors if needed
                const errorsArray = Array.isArray(err) ? err : [err];
                return errorsArray.map((e: any) => {
                  // Custom message untuk error email
                  if (
                    e.path?.includes("email") ||
                    e.validatorKey === "isEmail"
                  ) {
                    return "Format email tidak valid (contoh: nama@perusahaan.com)";
                  }
                  return e.message || JSON.stringify(e);
                });
              })
              .join(", ");
          } else {
            errorDetails = backendError.details || backendError.message || "";
          }
        }
        // Penanganan error dari frontend
        else if (error.message) {
          errorDetails = error.message;
          setOpenEditVendorDialog(false);
        }

        // Tampilkan error dalam Swal
        Swal.fire({
          icon: "error",
          title: errorTitle,
          html: `
          <div style="text-align: left;">
            <p><strong>${errorTitle}</strong></p>
            ${
              errorDetails
                ? `
              <div style="
                color: #d32f2f;
                background: #ffebee;
                padding: 10px;
                border-radius: 4px;
                margin-top: 8px;
                font-size: 0.9em;
              ">
                ${errorDetails.replace(/\n/g, "<br>")}
              </div>
            `
                : ""
            }
          </div>
        `,
          confirmButtonColor: "#0F62FE",
        });
      }
    }
  };

  // ======================================== end of function ========================================================
  // ============================================ start ui ===========================================================

  return (
    isLoading ? <LoadingOverlay /> :
    <Box sx={{ padding: 3 }}>
      {/* Header & Tabs */}
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}
      >
        <Typography variant="h6" fontWeight="bold">
          Vendor List
        </Typography>
      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }}
            size="small"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>

          {/* Search Button & Input */}
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )}

          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>

        {/* Right Controls */}
        <Box className="rightControls">
          <Button
            startIcon={<Delete />}
            variant="text"
            onClick={() => handleDeleteVendor(true)} // Pindahkan fungsi delete di sini
            disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          >
            Delete
          </Button>

          {/* Filter Button */}
          <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button>

          <Button
            startIcon={<Download />}
            variant="contained"
            className="exportButton"
            onClick={handleExport}
          >
            Export
          </Button>

          <Button
            startIcon={<Add />}
            variant="contained"
            className="addCategoryButton"
            onClick={handleOpenAddDialog} // Ganti dari setOpenAddEmployeeDialog
          >
            Add New Vendor
          </Button>
        </Box>
      </Box>

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of Vendor
        </Typography>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              <TableCell padding="checkbox" className="tableCell">
                <Checkbox
                  indeterminate={
                    selectedRows.length > 0 && selectedRows.length < rows.length
                  }
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(
                      selectedRows.length === rows.length
                        ? []
                        : rows.map((row) => row.vendorId)
                    )
                  }
                />
              </TableCell>
              <TableCell className="tableCell" width="50px">
                <strong>No</strong>
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("vendorName")}
                style={{ cursor: "pointer" }}
              >
                <strong>Vendor Name</strong>
                {sortConfig.orderBy === "vendorName" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("vendorAddress")}
                style={{ cursor: "pointer" }}
              >
                <strong>Vendor Address</strong>
                {sortConfig.orderBy === "vendorAddress" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("vendorType")}
                style={{ cursor: "pointer" }}
              >
                <strong>Vendor Type</strong>
                {sortConfig.orderBy === "vendorType" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("vendorContactNumber")}
                style={{ cursor: "pointer" }}
              >
                <strong>Vendor Contact Number</strong>
                {sortConfig.orderBy === "vendorContactNumber" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("vendorEmail")}
                style={{ cursor: "pointer" }}
              >
                <strong>Vendor Email</strong>
                {sortConfig.orderBy === "vendorEmail" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("vendorStatus")}
                style={{ cursor: "pointer" }}
              >
                <strong>Vendor Status</strong>
                {sortConfig.orderBy === "vendorStatus" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={9} align="center" style={{ color: "red" }}>
                  {error}
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow
                  key={row.vendorId}
                  selected={selectedRows.includes(row.vendorId)}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRows.includes(row.vendorId)}
                      onChange={(event) => {
                        event.stopPropagation();
                        handleSelectRow(row.vendorId);
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  <TableCell>
                    <strong>{row.vendorName}</strong>
                  </TableCell>
                  <TableCell>{row.vendorAddress}</TableCell>
                  <TableCell>{row.vendorType}</TableCell>
                  <TableCell>{row.vendorContactNumber}</TableCell>
                  <TableCell>{row.vendorEmail}</TableCell>
                  <TableCell>
                    <Box
                      className={`statusBadge ${getStatusClass(
                        row.vendorStatus
                      )}`}
                    >
                      {row.vendorStatus}
                    </Box>
                  </TableCell>
                  <TableCell className="tableCell">
                    <IconButton onClick={() => handleOpenEditDialog(row)}>
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>

        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* ======================= Filter Dialog ============================= */}
      <Dialog
        open={openFilterDialog}
        onClose={() => setOpenFilterDialog(false)}
      >
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {filters.map((filter, index) => {
            const usedFields = filters
              .map((f, i) => i !== index && f.field)
              .filter(Boolean);
            const availableOptions = availableFilters.filter(
              (opt) => !usedFields.includes(opt.value)
            );

            // Daftar nilai untuk vendor status
            const vendorStatusOptions = ["Active", "Inactive", "Suspended"];

            return (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                gap={1}
                mb={2}
              >
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) =>
                    handleFilterChange(index, "field", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                {filter.field === "vendorStatus" ? (
                  <TextField
                    select
                    label="Vendor Status"
                    variant="outlined"
                    size="small"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(index, "value", e.target.value)
                    }
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {vendorStatusOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : (
                  <TextField
                    label="Value"
                    variant="outlined"
                    size="small"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(index, "value", e.target.value)
                    }
                    sx={{ mt: 1 }}
                  />
                )}

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================== POPUP Add New Vendor =========================== */}
      <Dialog
        open={openAddVendorDialog}
        onClose={() => setOpenAddVendorDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Add New Vendor
          </Typography>
          <IconButton onClick={handleCloseAdd} color="error">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              gap: 3,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Grid container spacing={2}>
              {/* Profile Picture & Vendor ID */}
              <Grid item xs={6} sm={6}>
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    gap: 3,
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #aaa",
                    padding: 4,
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                    textAlign: "center",
                    cursor: "pointer",
                    position: "relative",
                  }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  {previewUrl ? (
                    <img
                      src={previewUrl}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: "8px",
                        objectFit: "contain",
                        maxHeight: 180,
                      }}
                    />
                  ) : (
                    <>
                      <PhotoCamera fontSize="large" />
                      <Typography variant="body2" color="textSecondary" mt={1}>
                        Drag & drop or click to upload image
                      </Typography>
                    </>
                  )}
                  <input
                    hidden
                    accept="image/png, image/jpeg, image/jpg"
                    type="file"
                    ref={fileInputRef}
                    onChange={(e) => handleFileUpload(e.target.files[0])}
                  />
                  <Typography variant="caption" mt={1}>
                    Max size: 5MB (.png, .jpg, .jpeg)
                  </Typography>
                </Box>

                {/* Form Input Section */}
                <Box sx={{ flex: 2 }}>
                  <TextField
                    fullWidth
                    label="Vendor Name"
                    margin="normal"
                    variant="outlined"
                    value={vendorDataAdd.vendorName}
                    sx={{ mb: 1 }}
                    name="vendorName"
                    placeholder="Enter Vendor Name"
                    error={!vendorDataAdd.vendorName}
                    helperText={
                      !vendorDataAdd.vendorName ? "Mandatory Field" : ""
                    }
                    onChange={handleInputChangeAdd}
                  />
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        sx={{ textAlign: "left", mb: 1 }}
                        value={vendorDataAdd.vendorType}
                        label="Vendor Type"
                        name="vendorType"
                        error={!vendorDataAdd.vendorType}
                        helperText={
                          !vendorDataAdd.vendorType ? "Mandatory Field" : ""
                        }
                        onChange={handleInputChangeAdd}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Supplier">Supplier</MenuItem>
                        <MenuItem value="Service Provider">
                          Service Provider
                        </MenuItem>
                        <MenuItem value="Contractor">Contractor</MenuItem>
                        <MenuItem value="Customer">Customer</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        sx={{ textAlign: "left", mb: 1 }}
                        value={vendorDataAdd.vendorStatus}
                        name="vendorStatus"
                        label="Vendor Status"
                        error={!vendorDataAdd.vendorStatus}
                        helperText={
                          !vendorDataAdd.vendorStatus ? "Mandatory Field" : ""
                        }
                        onChange={handleInputChangeAdd}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                        <MenuItem value="Suspended">Suspended</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                  <TextField
                    fullWidth
                    type="number"
                    label="Vendor Contact Number"
                    placeholder="Enter Vendor Contact Number"
                    value={vendorDataAdd.vendorContactNumber}
                    sx={{ mb: 1 }}
                    name="vendorContactNumber"
                    error={!vendorDataAdd.vendorContactNumber}
                    helperText={
                      !vendorDataAdd.vendorContactNumber
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeAdd}
                  />
                  <TextField
                    fullWidth
                    label="Vendor Email"
                    placeholder="Enter Vendor Email"
                    value={vendorDataAdd.vendorEmail}
                    sx={{ mb: 1 }}
                    name="vendorEmail"
                    error={!vendorDataAdd.vendorEmail}
                    helperText={
                      !vendorDataAdd.vendorEmail ? "Mandatory Field" : ""
                    }
                    onChange={handleInputChangeAdd}
                  />
                  <TextField
                    fullWidth
                    type="number"
                    placeholder="Enter Vendor Tax ID"
                    label="Vendor Tax ID"
                    value={vendorDataAdd.vendorTaxId}
                    sx={{ mb: 1 }}
                    name="vendorTaxId"
                    error={!vendorDataAdd.vendorTaxId}
                    helperText={
                      !vendorDataAdd.vendorTaxId ? "Mandatory Field" : ""
                    }
                    onChange={handleInputChangeAdd}
                  />
                  <Autocomplete
                    options={bankData}
                    value={vendorDataAdd.vendorBankName || null}
                    sx={{mb:1}}
                    onChange={(event, newValue) => {
                      handleInputChangeAdd({
                        target: {
                          name: "vendorBankName",
                          value: newValue || "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Bank Name"
                        placeholder="Select Bank"
                        fullWidth
                        error={!vendorDataAdd.vendorBankName}
                        helperText={
                          !vendorDataAdd.vendorBankName ? "Mandatory Field" : ""
                        }
                      />
                    )}
                    noOptionsText="No banks available"
                  />
                  <TextField
                    fullWidth
                    type="number"
                    label="Bank Account Number"
                    placeholder="Enter Vendor Bank Account Number"
                    value={vendorDataAdd.vendorBankAccountNo}
                    name="vendorBankAccountNo"
                    sx={{ mb: 1 }}
                    error={!vendorDataAdd.vendorBankAccountNo}
                    helperText={
                      !vendorDataAdd.vendorBankAccountNo
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeAdd}
                  />
                  <TextField
                    fullWidth
                    label="Bank Account Name"
                    placeholder="Enter Vendor Bank Account Name"
                    value={vendorDataAdd.vendorBankAccountName}
                    name="vendorBankAccountName"
                    error={!vendorDataAdd.vendorBankAccountName}
                    helperText={
                      !vendorDataAdd.vendorBankAccountName
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeAdd}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                {/* Map Placeholder */}
                <Box
                  sx={{
                    width: "100%",
                    height: "auto",
                    bgcolor: "inherit",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    my: 2,
                  }}
                >
                  <MapPinLocation
                    latitude={vendorDataAdd.latitude}
                    longitude={vendorDataAdd.longitude}
                    onSelect={({ lat, lng }) => {
                      // if (isEditing) {
                      setVendorDataAdd({
                        ...vendorDataAdd,
                        latitude: lat.toString(),
                        longitude: lng.toString(),
                      });
                      // }
                      // else {
                      //   setOfficeData({ ...officeData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                    }}
                  />
                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth
                    label="Input Latitude"
                    name="latitude"
                    placeholder="Enter latitude"
                    value={vendorDataAdd.latitude}
                    onChange={handleInputChangeAdd}
                    error={!vendorDataAdd.latitude}
                    helperText={
                      !vendorDataAdd.latitude ? "Mandatory Field" : ""
                    }
                  />
                  <TextField
                    fullWidth
                    label="Input Longitude"
                    name="longitude"
                    placeholder="Enter longitude"
                    value={vendorDataAdd.longitude}
                    onChange={handleInputChangeAdd}
                    error={!vendorDataAdd.longitude}
                    helperText={
                      !vendorDataAdd.longitude ? "Mandatory Field" : ""
                    }
                  />
                </Box>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Enter vendor address"
                  sx={{ textAlign: "left", mt: 1 }}
                  value={vendorDataAdd.vendorAddress}
                  name="vendorAddress"
                  error={!vendorDataAdd.vendorAddress}
                  helperText={
                    !vendorDataAdd.vendorAddress ? "Mandatory Field" : ""
                  }
                  onChange={handleInputChangeAdd}
                />
                <TextField
                  fullWidth
                  label="Country"
                  margin="normal"
                  variant="outlined"
                  placeholder="Enter Vendor Country"
                  value={vendorDataAdd.vendorCountry}
                  sx={{ mb: 1 }}
                  name="vendorCountry"
                  error={!vendorDataAdd.vendorCountry}
                  helperText={
                    !vendorDataAdd.vendorCountry ? "Mandatory Field" : ""
                  }
                  onChange={handleInputChangeAdd}
                />
                <TextField
                  fullWidth
                  label="Province"
                  name="vendorProvince"
                  placeholder="Enter Vendor Province"
                  sx={{ mb: 1 }}
                  value={vendorDataAdd.vendorProvince}
                  onChange={handleInputChangeAdd}
                  error={!vendorDataAdd.vendorProvince}
                  helperText={
                    !vendorDataAdd.vendorProvince ? "Mandatory Field" : ""
                  }
                />
                <TextField
                  fullWidth
                  label="Input City"
                  name="vendorCity"
                  placeholder="Enter Vendor City"
                  sx={{ mb: 1 }}
                  value={vendorDataAdd.vendorCity}
                  onChange={handleInputChangeAdd}
                  error={!vendorDataAdd.vendorCity}
                  helperText={
                    !vendorDataAdd.vendorCity ? "Mandatory Field" : ""
                  }
                />
                <TextField
                  fullWidth
                  label="District"
                  name="vendorDistrict"
                  placeholder="Enter Vendor District"
                  sx={{ mb: 1 }}
                  value={vendorDataAdd.vendorDistrict}
                  onChange={handleInputChangeAdd}
                  error={!vendorDataAdd.vendorDistrict}
                  helperText={
                    !vendorDataAdd.vendorDistrict ? "Mandatory Field" : ""
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
        >
          <Button variant="outlined" color="error" onClick={handleCloseAdd}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSaveAdd}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================================ POPUP Edit Vendor ======================================*/}
      <Dialog
        open={openEditVendorDialog}
        onClose={() => setOpenEditVendorDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Detail Vendor
          </Typography>
          <IconButton onClick={handleCloseEdit} color="error">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              mt: 2,
              display: "flex",
              gap: 3,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Grid container spacing={2}>
              {/* Profile Picture & Vendor ID */}
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #aaa",
                    padding: 4,
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                    textAlign: "center",
                    cursor: "pointer",
                    position: "relative",
                  }}
                  disabled={!isEditing}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    if (isEditing) {
                      e.preventDefault();
                      const file = e.dataTransfer.files[0];
                      handleEditFileUpload(file);
                    }
                  }}
                  onClick={() => {
                    if (isEditing) {
                      editFileInputRef.current?.click();
                    }
                  }}
                >
                  {vendorDataEdit.file ? (
                    <img
                      src={URL.createObjectURL(vendorDataEdit.file)}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: "8px",
                        objectFit: "contain",
                        maxHeight: 180,
                      }}
                    />
                  ) : vendorDataEdit.previewUrl ? (
                    <img
                      src={vendorDataEdit.previewUrl}
                      alt="Existing"
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: "8px",
                        objectFit: "contain",
                        maxHeight: 180,
                      }}
                    />
                  ) : (
                    <>
                      <PhotoCamera fontSize="large" />
                      <Typography variant="body2" color="textSecondary" mt={1}>
                        Drag & drop or click to upload image
                      </Typography>
                    </>
                  )}

                  <input
                    hidden
                    accept="image/png, image/jpeg, image/jpg"
                    type="file"
                    ref={editFileInputRef}
                    onChange={(e) => handleEditFileUpload(e.target.files[0])}
                  />
                  <Typography variant="caption" mt={1}>
                    Max size: 5MB (.png, .jpg, .jpeg)
                  </Typography>
                </Box>

                {/* Form Input Section */}
                <Box sx={{ mt: 2, flex: 2 }}>
                  <TextField
                    fullWidth
                    label="Vendor Name"
                    value={vendorDataEdit.vendorName}
                    sx={{ mb: 1 }}
                    name="vendorName"
                    disabled={!isEditing}
                    error={isEditing && !vendorDataEdit.vendorName}
                    helperText={
                      isEditing && !vendorDataEdit.vendorName
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        label="Vendor Type"
                        value={vendorDataEdit.vendorType}
                        name="vendorType"
                        error={!vendorDataEdit.vendorType}
                        disabled={!isEditing}
                        helperText={
                          isEditing && !vendorDataEdit.vendorType
                            ? "Mandatory Field"
                            : ""
                        }
                        onChange={handleInputChangeEdit}
                        sx={{ mb: 1 }}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Supplier">Supplier</MenuItem>
                        <MenuItem value="Service Provider">
                          Service Provider
                        </MenuItem>
                        <MenuItem value="Contractor">Contractor</MenuItem>
                        <MenuItem value="Customer">Customer</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        label="Vendor Status"
                        value={vendorDataEdit.vendorStatus}
                        name="religion"
                        error={!vendorDataEdit.vendorStatus}
                        disabled={!isEditing}
                        helperText={
                          isEditing && !vendorDataEdit.vendorStatus
                            ? "Mandatory Field"
                            : ""
                        }
                        onChange={handleInputChangeEdit}
                        sx={{ mb: 1 }}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                        <MenuItem value="Suspended">Suspended</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                  <TextField
                    fullWidth
                    type="number"
                    label="Vendor Contact Number"
                    value={vendorDataEdit.vendorContactNumber}
                    sx={{ mb: 1 }}
                    name="vendorContactNumber"
                    disabled={!isEditing}
                    error={isEditing && !vendorDataEdit.vendorContactNumber}
                    helperText={
                      isEditing && !vendorDataEdit.vendorContactNumber
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                  <TextField
                    fullWidth
                    label="Vendor Email"
                    value={vendorDataEdit.vendorEmail}
                    sx={{ mb: 1 }}
                    name="vendorEmail"
                    disabled={!isEditing}
                    error={isEditing && !vendorDataEdit.vendorEmail}
                    helperText={
                      isEditing && !vendorDataEdit.vendorEmail
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                  <TextField
                    fullWidth
                    type="number"
                    label="Vendor Tax ID"
                    value={vendorDataEdit.vendorTaxId}
                    sx={{ mb: 1 }}
                    name="vendorTaxId"
                    disabled={!isEditing}
                    error={isEditing && !vendorDataEdit.vendorTaxId}
                    helperText={
                      isEditing && !vendorDataEdit.vendorTaxId
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                  <Autocomplete
                    options={bankData}
                    sx={{mb:1}}
                    value={vendorDataEdit.vendorBankName || null}
                    onChange={(event, newValue) => {
                      handleInputChangeEdit({
                        target: {
                          name: "vendorBankName",
                          value: newValue || "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Bank Name"
                        placeholder="Select Bank"
                        fullWidth
                        error={isEditing && !vendorDataEdit.vendorBankName}
                        helperText={
                          isEditing && !vendorDataEdit.vendorBankName
                            ? "Mandatory Field"
                            : ""
                        }
                        disabled={!isEditing}
                      />
                    )}
                    noOptionsText="No banks available"
                    disabled={!isEditing}
                  />
                  <TextField
                    fullWidth
                    type="number"
                    label="Bank Account Number"
                    value={vendorDataEdit.vendorBankAccountNo}
                    name="vendorBankAccountNo"
                    disabled={!isEditing}
                    sx={{ mb: 1 }}
                    error={isEditing && !vendorDataEdit.vendorBankAccountNo}
                    helperText={
                      isEditing && !vendorDataEdit.vendorBankAccountNo
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                  <TextField
                    fullWidth
                    label="Bank Account Name"
                    value={vendorDataEdit.vendorBankAccountName}
                    name="vendorBankAccountName"
                    disabled={!isEditing}
                    error={isEditing && !vendorDataEdit.vendorBankAccountName}
                    helperText={
                      isEditing && !vendorDataEdit.vendorBankAccountName
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                {/* Map Placeholder */}
                <Box
                  sx={{
                    width: "100%",
                    height: "auto",
                    bgcolor: "inherit",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    my: 2,
                  }}
                >
                  <MapPinLocation
                    latitude={vendorDataEdit.latitude}
                    longitude={vendorDataEdit.longitude}
                    disabled={!isEditing}
                    onSelect={({ lat, lng }) => {
                      if (isEditing) {
                        setVendorDataEdit({
                          ...vendorDataEdit,
                          latitude: lat.toString(),
                          longitude: lng.toString(),
                        });
                      }
                    }}
                  />
                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth
                    label="Input Latitude"
                    name="latitude"
                    placeholder="Enter latitude"
                    value={
                      vendorDataEdit.latitude ? vendorDataEdit.latitude : ""
                    }
                    onChange={handleInputChangeEdit}
                    error={isEditing && !vendorDataEdit.latitude}
                    helperText={
                      isEditing && !vendorDataEdit.latitude
                        ? "Mandatory Field"
                        : ""
                    }
                    disabled={!isEditing}
                  />
                  <TextField
                    fullWidth
                    label="Input Longitude"
                    name="longitude"
                    placeholder="Enter longitude"
                    value={
                      vendorDataEdit.longitude ? vendorDataEdit.longitude : ""
                    }
                    onChange={handleInputChangeEdit}
                    error={isEditing && !vendorDataEdit.longitude}
                    helperText={
                      isEditing && !vendorDataEdit.longitude
                        ? "Mandatory Field"
                        : ""
                    }
                    disabled={!isEditing}
                  />
                </Box>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Vendor Address"
                  value={vendorDataEdit.vendorAddress}
                  sx={{ mt: 1, mb: 1 }}
                  name="vendorAddress"
                  disabled={!isEditing}
                  error={isEditing && !vendorDataEdit.vendorAddress}
                  helperText={
                    isEditing && !vendorDataEdit.vendorAddress
                      ? "Mandatory Field"
                      : ""
                  }
                  onChange={handleInputChangeEdit}
                />
                <TextField
                  fullWidth
                  label="Country"
                  name="vendorCountry"
                  placeholder="Enter Country"
                  sx={{ mb: 1 }}
                  disabled={!isEditing}
                  value={vendorDataEdit.vendorCountry}
                  onChange={handleInputChangeEdit}
                  error={!vendorDataEdit.vendorCountry}
                  helperText={
                    !vendorDataEdit.vendorCountry ? "Mandatory Field" : ""
                  }
                />
                <TextField
                  fullWidth
                  label="Province"
                  name="vendorProvince"
                  placeholder="Enter Province"
                  sx={{ mb: 1 }}
                  disabled={!isEditing}
                  value={vendorDataEdit.vendorProvince}
                  onChange={handleInputChangeEdit}
                  error={!vendorDataEdit.vendorProvince}
                  helperText={
                    !vendorDataEdit.vendorProvince ? "Mandatory Field" : ""
                  }
                />
                <TextField
                  fullWidth
                  label="Input City"
                  name="vendorCity"
                  placeholder="Enter City"
                  sx={{ mb: 1 }}
                  disabled={!isEditing}
                  value={vendorDataEdit.vendorCity}
                  onChange={handleInputChangeEdit}
                  error={!vendorDataEdit.vendorCity}
                  helperText={
                    !vendorDataEdit.vendorCity ? "Mandatory Field" : ""
                  }
                />
                <TextField
                  fullWidth
                  label="District"
                  name="vendorDistrict"
                  placeholder="Enter District"
                  sx={{ mb: 1 }}
                  disabled={!isEditing}
                  value={vendorDataEdit.vendorDistrict}
                  onChange={handleInputChangeEdit}
                  error={!vendorDataEdit.vendorDistrict}
                  helperText={
                    !vendorDataEdit.vendorDistrict ? "Mandatory Field" : ""
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          {!isEditing ? (
            // Tombol Edit Muncul di Awal
            <Button
              onClick={() => setIsEditing(true)}
              variant="contained"
              color="primary"
              sx={{ width: 120 }}
            >
              EDIT
            </Button>
          ) : (
            // Tombol Save & Cancel Muncul Saat Edit
            <>
              <Button
                onClick={() => setIsEditing(false)}
                variant="outlined"
                color="error"
                sx={{ width: 120 }}
              >
                CANCEL
              </Button>
              <Button
                onClick={handleSaveEdit}
                variant="contained"
                color="success"
                sx={{ width: 120 }}
              >
                SAVE
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default VendorListPage;
